module.exports = __webpack_public_path__ + "static/img/METABOLICAGE.6ce47c09.svg";